import styled from 'styled-components';


export const Divider = styled.div`
height: 1px;
background-color: #00000050;
`;
